import { render, staticRenderFns } from "./CnpjInput.vue?vue&type=template&id=506ecf31&scoped=true"
import script from "./CnpjInput.vue?vue&type=script&lang=js"
export * from "./CnpjInput.vue?vue&type=script&lang=js"
import style0 from "./CnpjInput.vue?vue&type=style&index=0&id=506ecf31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506ecf31",
  null
  
)

export default component.exports